import React, { SVGAttributes, useId } from 'react';
import Environment from '@config/index';
import clsx from 'clsx';
import styles from './icon.module.scss';

type IconProps = SVGAttributes<HTMLOrSVGElement> & {
  name: string;
  disableDefaultStyling?: boolean;
  ariaLabel?: string;
  ariaHidden?: boolean;
  title?: string;
};

const Icon: React.FC<IconProps> = (props) => {
  const { name, className, disableDefaultStyling = false, ariaLabel, ariaHidden, title, ...rest } = props;

  const titleId = useId();
  const isDecorative = ariaHidden || (!ariaLabel && !title && !name);

  return (
    <span className={className}>
      {/* @ts-ignore */}
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        className={clsx(!disableDefaultStyling && styles['vc-icon'])}
        aria-hidden={isDecorative}
        role={isDecorative ? 'presentation' : 'img'}
        // no aria-label if decorative
        {...(!isDecorative && (title ? { 'aria-labelledby': titleId } : { 'aria-label': ariaLabel || name }))}
        {...rest}
      >
        {title && !isDecorative && <title id={titleId}>{title}</title>}
        <use href={`${Environment.svgSpritePath}/${name}.svg#${name}`} />
      </svg>
    </span>
  );
};

export default Icon;
